module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-right-square-89452b5c.svg";